// removed by extract-text-webpack-plugin
module.exports = {"StatsBox":"StatsBox__StatsBox__2nyUA","StatsBoxContainer":"StatsBox__StatsBoxContainer__1Nybd","Row":"StatsBox__Row__1pbXQ","Col":"StatsBox__Col__1n6vG"};